import { URLS } from "@payping/utilities-shared/consts";
import { buildUrl } from "@payping/utilities-shared/url";
import { Divider, Flex, Typography, usePaypingContext } from "@payping/web-components";
import { FC } from "react";

interface Props {
  customerFullName: string;
  customerFatherName: string;
  customerNationalCode: string;
  customerAddress: string;
  customerCategoryName: string;
  customerWebsite: string;
  customerStartContract: string;
  customerEndContract: string;
  customerPlanPrice: string;
  customerPlanWagePercent: string;
  customerPlanWageAmount: string;
  customerPlanConstantAmount: string;
  customerShebaNumber: string;
  customerIsBussines: boolean;
  customerCompanyName: string;
}
const UserSignContractContent: FC<Props> = ({
  customerFullName,
  customerFatherName,
  customerNationalCode,
  customerAddress,
  customerWebsite,
  customerCategoryName,
  customerEndContract,
  customerStartContract,
  customerPlanPrice,
  customerPlanWagePercent,
  customerPlanWageAmount,
  customerPlanConstantAmount,
  customerShebaNumber,
  customerCompanyName,
  customerIsBussines,
}) => {
  const { breakpoints } = usePaypingContext();
  const { sm } = breakpoints;
  return (
    <div className="tw:p-4!">
      <ul className="tw:m-0! tw:list-none tw:p-0!">
        <li className="tw:pb-4!">
          <Typography.Text>ماده‌ی 1 طرفین قرارداد:</Typography.Text>
          <ul className="tw:m-0! tw:list-none tw:p-0!">
            <li>
              <Typography.Text>
                1-1) شركت مانا تدبیر آواتک به شناسه ملی 14005304514، شماره ثبت 480932، آقای احمد منصوری رشتی(مدیرعامل)،
                به نشانی: تهران، خیابان شریعتی، منظر نژاد، نبش کوچه جوادی، پلاک 4 و كدپستی 1948847413، که از این پس در
                این قرارداد «پرداخت‌یار» نـامیـده می‌شود.
              </Typography.Text>
            </li>
            {customerIsBussines ? (
              <li>
                <Typography.Text>
                  آقای/خانم {` ${customerFullName} `} ، فرزند {` ${customerFatherName} `} به شماره ملی
                  {` ${customerNationalCode} `} ،به نشانی: {` ${customerAddress} `}، به عنوان نماینده شرکت
                  {` ${customerCompanyName} `}. که از این پس در این قرارداد «پذیرنده» نـامیـده می‌شود و مجاز به انجام
                  فعالیت در زمینه‌ی {` ${customerCategoryName} `} می‌باشد.
                </Typography.Text>
              </li>
            ) : (
              <li>
                <Typography.Text>
                  2-1) آقای/خانم {` ${customerFullName} `} ، فرزند
                  {` ${customerFatherName} `} به شماره ملی {` ${customerNationalCode} `}، به نشانی:
                  {` ${customerAddress} `}
                  ،که از این پس در این قرارداد «پذیرنده» نـامیـده می‌شود و مجاز به انجام فعالیت در زمینه‌ی
                  {` ${customerCategoryName} `} می‌باشد.
                </Typography.Text>
              </li>
            )}
          </ul>
        </li>
        <li className="tw:pb-4!">
          <Typography.Text>ماده‌ی 2 موضوع و مدت قرارداد:</Typography.Text>
          <ul className="tw:m-0! tw:list-none tw:p-0!">
            <li>
              <Typography.Text>
                1-2) موضوع قرارداد، عبارت است از ارائه‌ی سرویس درگاه پرداخت یک‌پارچه‌ی آنلاین و پذیرش تراکنش‌های پذیرنده
                در وبسایت وی به آدرس
                {` ${customerWebsite} `} توسط «پرداخت‌یار» جهت انجام فعالیت کاری پذیرنده و پشتیبانی از این خدمت و همچنین
                ارائه‌ی خدمات زمینه‌ای در همین راستا به شرح بند‌های آتی.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                تبصره‌ی 1: ارئه‌ی هرگونه خدمت دیگر خارج از بندها و تعهدات این قرارداد، مستلزم توافق طرفین، عقد قرارداد
                جدید و پرداخت هزینه‌های مربوطه خواهد بود.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                2-2) شروع این قرارداد از مورخ {` ${customerStartContract} `} لغایت
                {` ${customerEndContract} `} خواهد بود.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                تبصره‌ی 2: باتوجه به مدت قرارداد، نوع همکاری و اقتضائات موضوع، طرفین مقرر و توافق نمودند که پس از انقضای
                مدت، این قرارداد به خودی خود، با همین شرایط، برای یک دوره‌ی دیگر (به مدت همین قرارداد) تمدید گردد، مگر
                آن‌که هریک از طرفین تمایل به تمدید قرارداد نداشته باشند که در این صورت، می‌بایست مراتب را کتباً به طرف
                دیگر اعلام و رسید اخذ نماید. بدیهیست که در صورت بروز هرگونه تغییر در هر یک از بندهای قرارداد، الحاقیه‌ای
                به قرارداد اضافه خواهد شد. لازم به ذکر است که این تمدید خودکار، تا زمان اعلام انصراف هریک از طرفین، برای
                هر دوره به قوت خود باقیست.
              </Typography.Text>
            </li>
          </ul>
        </li>
        <li className="tw:pb-4!">
          <Typography.Text>ماده‌ی 3 مبلغ قرارداد و نحوه‌ی پرداخت:</Typography.Text>
          <Typography.Text>مبلغ قرارداد در قبال ارائه ی خدمات موضوع ماده‌ی 2 عبارتست از:</Typography.Text>
          <ul className="tw:m-0! tw:list-none tw:p-0!">
            <li>
              <Typography.Text>
                3-1) مبلغ {` ${customerPlanPrice} `} ریال بعلاوه 10% مالیات بر ارزش افزوده که همزمان با انعقاد قرارداد
                توسط «پذیرنده» پرداخت می‌گردد؛
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                3-2)
                {` ${customerPlanWagePercent} `} درصد از مبلغ هر تراکنش تا سقف {` ${customerPlanWageAmount} `} ریال +{" "}
                {` ${customerPlanConstantAmount} `} ریال ثابت (بعلاوه 10% مالیات بر ارزش افزوده) که توسط «پذیرنده»،
                پرداخت می‌گردد؛
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                تبصره‌ی 3: چنانچه در اثنای مدت قرارداد، «پذیرنده» اقدام به فسخ قرارداد کرده یا قرارداد به درخواست وی
                اقاله گردد و یا اینکه موضوع قرارداد به دلیلی که مربوط به «پرداخت‌یار» نیست، قابل انجام نباشد و یا با
                ایجاد حق فسخ برای «پرداخت‌یار» و اعمال آن توسط نامبرده قرارداد فسخ گردد، مبلغ قرارداد قابل استرداد نمی
                باشد و چنانچه تعهدات مالی «پذیرنده» به طور کامل انجام نگرفته باشد، نامبرده مکلف به تسویه و پرداخت آن
                خواهد بود.
              </Typography.Text>
            </li>
          </ul>
        </li>
        <li>
          <Typography.Text>ماده‌ی 4 شروط ضمن قرارداد و تعهدات طرفین:</Typography.Text>
          <ul className="tw:m-0! tw:list-none tw:p-0!">
            <li>
              <Typography.Text>
                4-1) «پرداخت‌یار» متعهد است تا خدمات ارائه شده در راستای این قرارداد، همواره قابل دسترسی باشد و پشتیبانی
                لازم از خدمات خود را به طور تمام وقت، در تمام ایام هفته و در تمام شبانه‌روز ارائه دهد. مگر در صورتیکه
                خدمات ارائه شده از سمت سرویس دهنده اصلی قطع باشد.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                4-2) «پرداخت‌یار» متعهد است تا هرگونه اختلال مربوط به فعالیت خود را که از طریق شماره تلفن امداد
                02191097030 به مرکز پشتیبانی اعلام گردد را حداکثر ظرف مدت 72 ساعت کاری پشتیبانی نموده و حسب مورد رفع
                ایراد کرده یا اقدامات مربوطه را انجام و سیر پشتیبانی را به اطلاع «پذیرنده» برساند.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                تبصره‌ی 4: با توجه به مشكلات و اختلالات احتمالي در شبكه‌ی بانكي، مسئولیت بروز هرگونه اشكال، قطعي یا
                تأخیر در پرداخت‌یاری، شبكه‌ی بانكي یا در سیستم تسویه‌ی شاپرک، متوجه «پرداخت‌یار» نمي‌باشد.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                3-4) «پرداخت‌یار» متعهد است تا به صورت مستمر، وجوه ناشی از هر تراکنش را محاسبه نموده و پس از کسر وجوه
                مندرج در ماده‌ی 3 قرارداد، به حساب معرفی شده از سوی پذیرنده به شماره‌ی {` ${customerShebaNumber} `}{" "}
                واریز نماید. لازم به ذکر است که عملیات تسویه، بر اساس آخرین ویرایش فصل «الزامات، ضوابط و فرآیند اجرایی
                فعالیت پرداخت‌یاران و پذیرندگان پشتیبانی شده در نظام پرداخت کشور»، انجام خواهد شد.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                4-4) «پرداخت‌یار» در تمام مدت قرارداد و ارائه‌ی خدمات به «پذیرنده»، نظارت خود بر فعالیت‌های «پذیرنده» را
                بر اساس الزامات «شرکت‌های پرداخت‌یار در ارائه‌ی خدمات بر روی درگاه پرداخت اینترنتی»، اعمال خواهد نمود.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                5-4) استفاده از سرویس‌های ارائه شده توسط «پرداخت‌یار»، مشمول قوانین جاری کشور در تمام زمینه‌ها می‌باشد.
                لذا «پذیرنده» متعهد به اجرای کامل قوانین جاری کشور، از جمله مقررات و قوانین مبارزه با پولشوئی و تأمین
                مالی تروریسم و همچنین اخذ مجوزهای لازمه جهت فعالیت‌های خود می‌باشد. بدیهیست مسئولیت عدم اخذ مجوزات و
                هرگونه فعالیت خلاف مقررات کشور، برعهده‌ی «پذیرنده» بوده و مسئولیتی بدین جهت متوجه «پرداخت یار» نخواهد
                بود.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                6-4) استفاده از «پرداخت‌یاری» مشمول قوانین و مقررات نظام پولشویی کشور (که از سوی بانک مرکزی ابلاغ
                می‌گردد) می‌باشد. لذا «پذیرنده» متعهد است تا این قوانین را نیز تماماً اجرا و در نظر داشته باشد.
                «پرداخت‌یار» تنها وظیفه‌ی در دسترس بودن و اجرای سرویس ارائه شده را برای «پذیرنده» دارد و هیچ گونه
                مسئولیتی در قبال شماره حساب اعلامی «پذیرنده»، مبلغ و یا ماهیت فعالیت «پذیرنده»، ندارد و کلیه‌ی
                مسئولیت‌های حقوقی، قانونی و مادی ناشی از تراکنش های انجام گرفته، ماهیت انتقال وجه و خریدها و غیره، به
                عهده‌ی «پذیرنده» می باشد.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                تبصره‌ی 5: با توجه به ممنوعیت ارائه‌ی خدمات پرداخت‌یاری به فعالین حوزه‌ی خرید و فروش ارز و یا مسکوکات
                طلا و نقره و همچنین اشخاصی که در عنوان فروشگاه یا شرکت خود از کلمه‌ی صرافی یا ترکیبات مشابه آن استفاده
                نموده‌اند، «پذیرنده» اعلام و تعهد نمود که هیچ‌گونه فعالیتی در امور فوق‌الذکر نداشته و نخواهد داشت و از
                کلمه‌ی صرافی یا ترکیبات مشابه آن در نام فروشگاه یا شرکت خود استفاده ننماید.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                4-7) چنان‌چه مشاهده و معلوم گردد که «پذیرنده» از سرویس پرداخت‌یاری ارائه شده، جهت انجام اعمال مجرمانه و
                یا فعالیت‌های ممنوعه بهره‌برداری و استفاده می‌نماید، شرکت «پرداخت‌یار» و یا شاپرک، مجازند تا رأساً نسبت
                به توقف ارائه‌ی خدمات پرداخت به «پذیرنده» اقدام نمایند و «پذیرنده» حق طرح هرگونه ادعا یا اعتراضی در این
                خصوص را از خود سلب و ساقط نمود.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                4-8) «پذیرنده» با امضاء این قرارداد، به شرکت شاپرک و همچنین بانک مرکزی اختیار و اجازه داد تا در صورت
                واریز اشتباه وجوه به حساب «پذیرنده» تحت هر عنوانی، وجوه مذکور را از حساب پذیرنده برداشت نمایند.
              </Typography.Text>
            </li>

            <li>
              <Typography.Text>
                9-4) «پذیرنده » موظف است حداکثر مبلغ مجاز در هر تراکنش که از طرف شرکت پرداخت‌یار به وی اعلام می‌شود را
                رعایت نموده و از ارسال تراکنش با بیش از مبلغ تعیین شده، خودداری نماید.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                10-4) «پذیرنده » متعهد گردید که از خدمات درگاه پرداخت اینترنتی، صرفاً برای خدمات مجاز که حقیقتاً انجام
                می‌شود، استفاده نموده و از انجام هرگونه معامله‌ی صوری یا شبیه‌سازی از طریق خدمات درگاه پرداخت اینترنتی
                پرهیز نماید.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                11-4) «پذیرنده» متعهد گردید که بابت پرداخت وجه از طریق درگاه پرداخت اینترنتی، هیچ‌گونه مبلغ اضافی به هر
                نحو و تحت هر عنوانی از دارنده‌ی کارت دریافت نکند.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                12-4) چنانچه وجهی به اشتباه بصورت اضافی به حساب «پذیرنده» واریز شود، «پذیرنده» مجاز به برداشت وجه واریزی
                اضافی نبوده و می‌بایست مراتب را سریعاً به پرداخت‌یار اطلاع دهد. همچنین مراجع ذی‌صلاح مجاز هستند رأساً و
                بدون انجام هیچ تشریفاتی در رفع اشتباه و برگشت وجوه از حساب «پذیرنده » اقدام کنند. همچنین در صورت برداشت
                سهوی وجه واریزی اضافه، «پذیرنده» متعهد است حداکثر ظرف 72 ساعت، وجه مربوطه را تأمین و مسترد نماید.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                13-4) «پذیرنده» مطلع گردیده و توافق نمود که در صورت صدور دستور قضایی و یا در صورت احراز هر قسم
                بهره‌برداری غیر مجاز از «ابزار پذیرش» توسط وی، ضمن درج نام متخلف در فهرست سیاه، ارائه‌ی کلیه‌ی خدمات
                پرداخت الکترونیک به ایشان ازجانب تمامی «شرکت‌های ارائه دهنده‌ی خدمات پرداخت» و سایر «پرداختیاران» تعلیق
                گردد. احراز بهره‌برداری غیرمجاز و مغایر با الزامات و مقررات شبکه‌ی پرداخت، در صلاحیت «شاپرک» و یا «بانک
                مرکزی» خواهد بود.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                14-4) پذیرنده متعهد است در چارچوب قوانین و مقررات جمهوری اسلامی ایران فعالیت داشته و مجوزهای لازم برای
                فعالیت خود را از مراجع ذی‌صلاح اخذ نموده باشد.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                15-4) «پذیرنده» متعهد گردید که در صورت تغییر در صنف و یا سایر موارد و اطلاعات ارائه شده به پرداخت‌یار
                جهت شناسایی، از قبیل تغییر مندرجات روزنامه‌ی رسمی برای اشخاص حقوقی، اطلاعات تماس، تغییر مجوز کسب و غیره،
                مجوزهای مربوطه را کسب نموده و مراتب را به پرداخت‌یار اعلام نماید.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                16-4) «پذیرنده» متعهد گردید که درصورت تغییر اطلاعات هویتی (مانند تغییر مدیرعامل برای پذیرندگان حقوقی)،
                تغییر اطلاعات مکانی و یا تغییر صنف (تغییر کسب و کار)، موضوع را در اسرع وقت به پرداخت‌یار اطلاع‌رسانی
                نموده و مدارک مثبته درخصوص تغییر صورت گرفته را به پرداخت‌یار ارائه نماید.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                17-4) «پذیرنده» متعهد گردید که هرگونه تغییر در IP یا دامنه‌های اختصاص داده شده (طبق لیست ارائه شده توسط
                پرداخت‌یار) رابه پرداخت‌یار اعلام نماید و مطلع گردید که پردازش تراکنش‌های خارج از لیست مذکور، برای
                پرداخت‌یار غیرمجاز می‌باشد و امکان پذیر نیست.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                18-4) «پذیرنده» متعهد گردید که پرداخت اینترنتی خود را صرفاً جهت بهره‌برداری در حوزه فروش کالا، خدمات و
                محصولات مجاز مندرج در قرارداد، مورد استفاده قرار داده و سرویس پرداخت اینترنتی خود را به هیچ صورتی (اعم
                از استفاده، اجاره و یا واگذاری) در اختیار شخص حقیقی یا حقوقی دیگری قرار ندهد.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                19-4) «پذیرنده» متعهد گردید، که شماره‌ی پشتیبانی پرداخت‌یار را در سایت خود درج نماید.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                20-4) «پذیرنده» متعهد گردید تا به کلیه قوانین تجارت الکترونیک کشور و مقررات عمومی و الزامات این حوزه که
                از سوی بانک مرکزی ج.ا.ا و شاپرک وضع شده است، پایبند باشد.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                12-4) «پذیرنده» موظف و متعهد به بهره‌برداری صحیح از خدمات پرداخت اینترنتی با شرایط تعیین شده در قرارداد
                و ابلاغیه‌های شرکت پرداخت‌یار و منطبق با مقررات این حوزه که توسط بانک مرکزی ج.ا.ا و یا شرکت شاپرک اعلام
                گردیده، می‌باشند. همچنین «پذیرنده» متعهد است تا در صورتیکه متوجه هرگونه سوءاستفاده احتمالی از فرآیند
                خدمات درگاه پرداخت اینترنتی شد، مراتب را در اسرع وقت به شرکت پرداخت‌یار اطلاع دهد.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                22-4) كليه‌ی تذکرات و قوانین مندرج در قسمت قوانين و مقررات وبسايت «پرداخت‌یار» به آدرس payping.ir/terms،
                جزئي از اين قرارداد تلقي شده و «پذیرنده» متعهد به رعایت آن‌ها همچون مفاد این قرارداد می‌باشد. همچنین در
                صورت بروز تغییر در قوانین مذکور یا ملاحظات «پرداخت‌یار»، قوانین جدید و تغییرات یافته، در این قرارداد
                جاری می‌باشند.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                23-4) كليه‌ی اطلاعات «پذیرنده» (اعم از اطلاعات شخصی و مالی)، نزد «پرداخت‌یار» محرمانه تلقي مي‌شود و بدون
                درخواست و تأیید کتبی ایشان، در اختیار اشخاص ثالث (بجز بانک مرکزی جمهوری اسلامی ایران، شرکت شاپرک و شرکت
                ارائه دهنده‌ی خدمات پرداخت طرف قرارداد)، قرار نخواهد گرفت، مگر به حكم قانون يا با دستور مقام صالح قضايي.
                در اين خصوص، بدیهیست که به اشتراک گذاردن اطلاعات ارائه شده توسط «پذیرنده» در بين كاركنان «پرداخت‌یار»
                براي پیشبرد اهداف قرارداد، بلامانع و لازمه‌ی انجام موضوع قرارداد است.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                24-4) «پذیرنده» متعهد است در صورت نیاز بانک مرکزی جمهوری اسلامی ایران یا شرکت شاپرک، به هرگونه اطلاعاتی،
                اطلاعات درخواستی را در مدت زمان تعیین شده در درخواست، در اختیار «پرداخت‌یار» قرار دهد. تخلف از این بند،
                موجب قطع خدمات «پرداخت‌یار» شده و «پذیرنده» حق طرح هرگونه ادعا و اعتراضی در این خصوص را از خود سلب و
                ساقط نمود.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                25-4) «پذیرنده» به هبچ‌وجه و طریقی مجاز به داشتن پذیرنده‌ی دیگر در ذیل خود و تجمیع وجوه سایر پذیرندگان،
                نمی‌باشد. بدیهیست که در صورت تخلف «پذیرنده»، «پرداخت‌یار» حق دارد تا خدمات ارائه شده به «پذیرنده» و
                دسترسی وی را به صورت یک طرفه قطع نماید و در این صورت، «پذیرنده» حق طرح هیچ‌گونه ادعا و اعتراضی را نخواهد
                داشت.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                26-4) چنانچه «پذیرنده» در هر زمان و مرحله‌ای از انجام تعهدات و وظایف قراردادی یا قانونی خود امتناع ورزد،
                «پرداخت‌یار» حق قطع خدمات و دسترسی «پذیرنده» به خدمات به صورت یک طرفه و عنداللزوم، فسخ یک‌طرفه‌ی قرارداد
                حاضر ـ بدون طی هرگونه تشریفات ـ را خواهد داشت.
              </Typography.Text>
            </li>
            <li>
              <Typography.Text>
                27-4) اقامتگاه قانوني طرفين همان است كه در مقدمه قرارداد نوشته شده است. در صورتيكه يكي از طرفين،
                اقامتگاه قانوني خود را تغيير دهد بايد نشاني خود را ظرف مدت ١٥روز پيش از تغيير به طرف ديگر اطلاع دهد. تا
                زماني كه نشاني جديد به طرف ديگر اعلام نشده است، كليه مكاتبات به نشاني قبلي ارسال ميشود و دريافت شده تلقي
                ميگردد.
              </Typography.Text>
            </li>
          </ul>
        </li>
      </ul>
      <Flex
        className="tw:mt-10! tw:w-full tw:sm:px-16!"
        justify="space-between"
        gap={"32px"}
        align="center"
        vertical={!sm}
      >
        <Flex vertical gap={"small"}>
          <Typography.Text>احمدرضا منصوری</Typography.Text>
          <Divider className="tw:m-0!" />
          <img
            className="tw:h-auto tw:w-37.5"
            src={buildUrl(URLS.STORAGE_URL, "payping/payping-signature.png").toString()}
          />
        </Flex>
        <Flex vertical gap={"small"}>
          <Typography.Text>پذیرنده:‌ {` ${customerFullName} `}</Typography.Text>
          <Divider className="tw:m-0!" />
          <Typography.Text>محل امضا</Typography.Text>
        </Flex>
      </Flex>
    </div>
  );
};

export default UserSignContractContent;
